module.exports = __webpack_public_path__ + "media/YEAH_Scribble_Kopf_Dani_480x480.1a1622e8.mp4";